import type { IPoint } from '@/modules/Editor/point'

export const euclideanDistance = (point1: IPoint, point2: IPoint): number => {
  const distanceX = point1.x - point2.x
  const distanceY = point1.y - point2.y
  return Math.sqrt(distanceX * distanceX + distanceY * distanceY)
}
